import {openDb} from '../../../Services/BrowserDatabaseIDB';
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";

export function getAllEventsSummaryList(_user_id) {
    console.log('getAllEventsSummaryList : ' + _user_id);

    // FIX: Check if the user ID is invalid/missing, and if so, return an empty array promise.
    if (_user_id === "" || _user_id === undefined || _user_id === null) {
        console.log('User ID is missing or invalid. Returning empty event list.');
        return Promise.resolve([]);
    }

    // 1. Ensure all required stores are created (with correct keyPaths)
    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        // 2. Create a readonly transaction spanning both required stores
        const tx = db.transaction(['Account', 'Events'], 'readonly');

        const accountStore = tx.objectStore('Account');
        const eventsStore = tx.objectStore('Events');

        // 3. CORRECTED: Get the Account record using the actual user ID (_user_id)
        // IndexedDB looks for the object whose 'id' field matches the value of _user_id.
        const accountPromise = accountStore.get(_user_id);

        // Get all events
        const eventsPromise = eventsStore.getAll();

        // Use Promise.all to wait for both database operations to complete
        return Promise.all([accountPromise, eventsPromise]);

    }).then(function ([_account, _events]) {
        // 4. Verification check is now redundant but kept for safety
        if (_account && _account.id === _user_id) {
            return _events.map((evt) => ({
                id: evt.id,
                title: evt.title,
                time_table: evt.time_table
            }));
        } else {
            // This case should primarily catch when the account doesn't exist
            console.log('Account not found for ID:', _user_id);
            return null;
        }
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error;
    });
}


export function getEventAttendees(_event_id) {
    console.log('getEventAttendees : '+_event_id);

    return openDb('pa', 1, function (upgradeDb) {
        if (!upgradeDb.objectStoreNames.contains('pa_data')) {
            upgradeDb.createObjectStore('pa_data');
            upgradeDb.createObjectStore('pa_photos');
        }
    }).then(function (db) {
        const tx = db.transaction('pa_data', 'readonly');
        const store = tx.objectStore('pa_data');

        return store.get('Events');
    }).then(function (_events) {
        // check for matching event
        if (_events) {
            console.log('All Events:', _events);

            // Extract the actual ID if the AI wrapped it like eventId="..."
            const cleanedEventId = _event_id.match(/["']?([a-f0-9]{24})["']?$/i)?.[1] || _event_id;
            console.log('Cleaned Event ID:', cleanedEventId);

            // Now find the event
            const event = _events.find(evt => String(evt.id) === cleanedEventId);

            if (event) {
                console.log('Matched Event:', event);
                console.log('Event Attendees:', event.attendees);
                return event.attendees;
            } else {
                console.log('Event not found with ID:', cleanedEventId);
                return null;
            }
        } else {
            console.log('No events found.');
            return null;
        }
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}